<template>
  <div class="step_inner">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-result icon="success"  subTitle="发布的职位审核中，审核完毕会直接发布">
            <template slot="extra">
              <el-button @click="next">查看职位</el-button>
              <el-button type="primary" @click="next">完成</el-button>

            </template>
          </el-result>
        </el-col> 

      </el-row>
     
  </div>
</template>

<script>

export default {


  data () {
    return {

    }
  },

  mounted () {
  },
  methods:{
    next(){
      this.$router.push({ name: "director-work-demand" });
    },

  

    // 点击上一步
    handleLastStep() {
      this.$emit('handleLastStep')
    },
    
    // 点击下一步
    handleNextStep() {
      this.$emit('handleNextStep')
    },


    
  }
}
</script>


<style lang="scss" scoped>
.step_inner {
  h2 {
    margin: 0;
    font-size: 19px;
    line-height: 50px;
  }
  .el-col {
    min-height: 51px;
  }
}


.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>